export enum LangType {
  EN = "en",
  TW = "tw"
}
